export enum CardOrderingItemStatus {
  CARD_ORDER_ITEM_CREATED = 0,
  CARD_ORDER_ITEM_ORDERED = 1,
  CARD_ORDER_ITEM_PRINTED = 2
}
